import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Workshop } from 'src/models/workshop';
import { APIServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-advisor-blocked-schedule-service';

import { AdvisorsComponent } from '../../../advisors.component';
import { advisor } from '../../../../../../models/advisor';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-delete-lock-settings-advisor',
    templateUrl: './delete-lock-settings-advisor.dialog.html',
    styleUrls: ['./delete-lock-settings-advisor.dialog.sass'],
    standalone: false
})
export class deleteLockSettingsAdvisorDialog {
  constructor(

    public helperService: HelperService,
    public dialogRef: MatDialogRef<AdvisorsComponent>,
    @Inject(MAT_DIALOG_DATA) public lockSetting: any,
    public AdvisorBlockedScheduleService: APIServiceAdvisorBlockedSchedule,
    private translate: TranslateService,
  ) {}
  LoadingSavingLocks:boolean = false;
  ngOnInit(): void {

  }
 // Funtion delete or cancel dialog
  onCancel(): void {
    this.dialogRef.close();
  }
  onSave(): void {

    this.LoadingSavingLocks = true
   this.AdvisorBlockedScheduleService.deletClusterlocksettings(this.lockSetting.advisorId,this.lockSetting.initialDate,this.lockSetting.finalDate,this.lockSetting.hourInitial ,this.lockSetting.hourFinal)
      .pipe(finalize(() => null))
      .subscribe({
        next: (response) => {

          if (
            response.message ===
            'Data Deleted Successfully'
          ) {
            const translateText = this.translate.instant("ToastDeleteBlockHistoryWorkshop"
            );

            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateText
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)
            this.LoadingSavingLocks = false
            this.dialogRef.close();
          }
        },
        error: (failed) => {
          // Validation 401 error
          if(failed.status === 401){
            this.helperService.logoutToken()
          }

          let mensageError = failed.error.text;
          this.LoadingSavingLocks = false

          if (
          mensageError ===
            "{ 'code': '400', 'message': 'Exception: An error occurred while saving the entity changes. See the inner exception for details.' }"
          ) {

          }
        },
      });
  }

}
